export default __webpack_public_path__ + "static/media/Dr.Prarthana-B-Desai-MD-FRGUHS-Aesthetic-Dermatology.0ddcf66a.jpg";